import { api } from "../Apis/interceptor";

// export  const getCustomer = function(currCustomer){
//    return api.get(`/api/v1/customer/${currCustomer}`);
// }

// export const getControlField = function(currCustomer){
//     return api.get(`/api/v1/customerControlField/${currCustomer}`);
// }

export const getToolTip = function (customer_id) {
  return api.get("/api/v1/getToolTip/" + customer_id);
};

export const updateToolTip = function (customer_id, toolTipData) {
  return api.put("/api/v1/updateToolTip/" + customer_id, toolTipData);
};

export const TooltipUpdate = function (customer_id) {
  return api.put("/api/v1/toolTipConfig/" + customer_id);
};
//Field
export const getField = function (id) {
  return api.get("/api/v1/customerField/" + id);
};

//table config
export const getTable = function (id) {
  return api.get("/api/v1/customerTable/" + id);
};
// control panel config
export const getControlField = function (id) {
  return api.get("/api/v1/customerControlField/" + id);
};

//survey config
export const getSurveyField = function (id) {
  return api.get("/api/v1/customerSurveyTable/" + id);
};

//survey config
export const generateApi = function (sub_modules) {
  return api.post("/api/v1/generateApi/", sub_modules);
};

//opporutinity list
export const getOpportunity = function (customer_id) {
  return api.get("/api/v1/getOppList/" + customer_id);
};

//client list
export const getClient = function (customer_id) {
  return api.get("/api/v1/getClientList/" + customer_id);
};

//save Emails
export const saveEmail = function (customer_id, externalEmailData) {
  return api.post("/api/v1/saveExternalEmail/" + customer_id, {
    externalEmailData: externalEmailData,
  });
};
//Check  user name
// export const checkUser=function(customer_id,externalEmailData){
// 	return api.post('/api/v1/checkExternalUser/'+customer_id,{externalEmailData:externalEmailData});
// };
//Check Emails
export const checkEmail = function (customer_id, externalEmailData) {
  return api.post("/api/v1/checkExternalEmail/" + customer_id, {
    externalEmailData: externalEmailData,
  });
};

//get Emails
export const getEmail = function (customer_id) {
  return api.get("/api/v1/getExternalUsersEmail/" + customer_id);
};

//remove Emails
export const removeExternalUser = function (selectedIndexes) {
  return api.put("/api/v1/removeExternaluser/", {
    selectedIndexes: selectedIndexes,
  });
};
//remove Single Emails
// export const removeExternalSingleUser=function(selectedIndexes){
// 	return api.put('/api/v1/removeExternalSingleUser/',{selectedIndexes:selectedIndexes});
// };

//update Emails
export const updateExternalUser = function (emailData) {
  return api.put("/api/v1/updateExternaluser/", { emailData: emailData });
};

//save survey Template
export const saveTemplate = function (
  customer_id,
  templateData,
  templateName,
  module
) {
  return api.post("/api/v1/saveTemplate/" + customer_id + "/" + module, {
    templateData: templateData,
    templateName: templateName,
  });
};

//update survey Template
export const updateSurveyTemplate = function (
  temp_id,
  templateData,
  templateName,
  module
) {
  return api.put("/api/v1/updateSurveyTemplate/" + temp_id + "/" + module, {
    templateData: templateData,
    templateName: templateName,
  });
};

//get survey Template
export const getSurveyTemplate = function (customer_id, module) {
  return api.get("/api/v1/getSurveyTemplate/" + customer_id + "/" + module);
};

//get surveyLogs
export const getSurveyLogs = function (admin_user_id) {
  return api.get("/api/v1/getsurveyLogs/" + admin_user_id);
};

//get survey Template
export const getSavedTemplate = function (customer_id, template_id) {
  return api.get("/api/v1/getSavedTemplate/" + customer_id + "/" + template_id);
};

//get survey Template
export const sendSurveyMail = function (surveyToolData) {
  return api.put("/api/v1/sendSurveyMail", { surveyToolData: surveyToolData });
};

//remove Template
export const removeSavedTemplate = function (id) {
  return api.delete("/api/v1/removeSavedTemplate/" + id);
};
// surveyApprovedStatus
export const surveyApprovedStatus = function (surveyId, localData) {
  return api.put("/api/v1/surveyApprovedStatus/" + surveyId, { localData });
};
// reject mail
export const surveyRejectMail = function (surveyId, rejectionComment) {
  return api.put("/api/v1/surveyRejectMail/" + surveyId, {
    rejectionComment: rejectionComment,
  });
};

//update field config
export const updateFieldConfig = function (temp_id, fieldConfigData) {
  return api.put("/api/v1/updateFieldData/" + temp_id, {
    fieldConfigData: fieldConfigData,
  });
};

//update table config
export const updateTableConfig = function (customer_id, tableConfigData) {
  return api.put("/api/v1/updateTableData/" + customer_id, {
    tableConfigData: tableConfigData,
  });
};

export const confirmFieldReset = function (customer_id) {
  return api.put("/api/v1/updateResetFieldData/" + customer_id);
};

//reset table config
export const confirmTableReset = function (customer_id) {
  return api.put("/api/v1/updateResetTableData/" + customer_id);
};

//save surveyToolLogs
export const saveSurveyLogs = function (surveyLogData, surveyFormId) {
  return api.post("/api/v1/saveSurveyLogs/" + surveyFormId, {
    surveyLogData: surveyLogData,
  });
};

//save add-survey
export const addsurveydata = function (addsurveydata) {
  return api.post("/api/v1/addsurveydata", { addsurveydata: addsurveydata });
};
// getSurveyList
export const getSurveyList = function (curUser) {
  return api.post("/api/v1/getSurveyList", { curUser: curUser });
};

//get dynamic fields
export const getDynamicLabel = function (customerId, fieldKeyArray, module) {
  return api.get(
    "/api/v1/get-dynamic-label?customerId=" +
      customerId +
      "&fieldKeyArray=" +
      JSON.stringify(fieldKeyArray) +
      "&module=" +
      module
  );
};
